export default function SkalaLogo({ size = "md" }) {
    const textSize = size === "lg" ? "text-3xl" : "text-2xl";
    const markSize = size === "lg" ? 28 : 24;
    return (
        <span className="flex items-center gap-2.5 select-none">
            <span
                aria-hidden
                className="relative grid place-items-center rounded-md"
                style={{
                    width: markSize + 10,
                    height: markSize + 10,
                    background: "hsl(30 8% 12%)",
                    boxShadow: "inset 0 0 0 1px hsl(158 42% 46% / 0.55)",
                }}
            >
                <svg width={markSize} height={markSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 18L10 12L13 15L20 6" stroke="hsl(40 14% 96%)" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15 6H20V11" stroke="hsl(158 42% 54%)" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
            <span className={`font-display font-semibold ${textSize} tracking-tight text-foreground`}>
                Adrise
            </span>
        </span>
    );
}
